import { CurrencyCodeType } from '@/types/currency';

import { CURRENCY_SYMBOL_DATA_MAP } from './constants';

export const isPrefixCurrencySymbol = (
  currency?: CurrencyCodeType
): boolean => {
  /**
   * Most currency symbols appear as a prefix,
   * so if we cannot recognize the type or currency or it is not provided,
   * we set the value to 'true'
   */
  if (!currency) return true;

  const currencyCode = currency.toUpperCase() as CurrencyCodeType;

  return CURRENCY_SYMBOL_DATA_MAP[currencyCode]?.isPrefix !== undefined
    ? CURRENCY_SYMBOL_DATA_MAP[currencyCode].isPrefix
    : true;
};
